import { useState, useCallback, useEffect } from 'react'
import * as React from 'react'
import Styles from './SearchInput.module.scss'
import { connectSearchBox } from 'react-instantsearch-dom'
import { Search } from 'blaze-ui/icons/20'
import { Search as Search32 } from 'blaze-ui/icons/32'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export interface Props {
  onFocus: () => void
  placeholder: string | undefined
  inputRef: React.Ref<HTMLInputElement> | undefined
  disabled?: boolean
  refine: (value: string) => void
  initialValue?: string
  onInputChange: (value: string) => void
}

const SearchInput = ({ refine, onFocus, placeholder, inputRef, disabled, initialValue, onInputChange }: Props) => {
  const [searchValue, setSearchValue] = useState(initialValue || '')
  const { isMobile } = useResponsiveDesign()

  const onChange = useCallback(
    (event: any) => {
      const value = event.currentTarget.value

      setSearchValue(value)
      refine(value)
      onInputChange?.(value)
    },
    [refine, onInputChange],
  )

  useEffect(() => {
    setSearchValue(initialValue || '')
  }, [initialValue])

  return (
    <>
      <div className={Styles.searchIcon}>{isMobile ? <Search /> : <Search32 />}</div>
      <input
        autoFocus={true}
        className={Styles.input}
        onChange={onChange}
        onFocus={onFocus}
        placeholder={placeholder}
        ref={inputRef}
        disabled={disabled}
        autoComplete={'off'}
        value={searchValue}
      />
    </>
  )
}

export const ConnectedSearchInput: React.ComponentClass<any, Props> = connectSearchBox(SearchInput)
